import { render, staticRenderFns } from "./crowd-strand.vue?vue&type=template&id=33680139&scoped=true&"
import script from "./crowd-strand.vue?vue&type=script&lang=ts&"
export * from "./crowd-strand.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-strand.vue?vue&type=style&index=0&id=33680139&prod&lang=scss&scoped=true&"
import style1 from "./crowd-strand.vue?vue&type=style&index=1&id=33680139&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33680139",
  null
  
)

export default component.exports